import React, { useEffect } from "react";
import { SkipToContent } from "@/components/site/SkipToContent";
import { StickyHeader } from "@/components/site/StickyHeader";
import { Hero } from "@/components/site/Hero";
import { IntentHub } from "@/components/site/IntentHub";
import { AboutHistory } from "@/components/site/AboutHistory";
import { UpcomingEvents } from "@/components/site/UpcomingEvents";
import { Programs } from "@/components/site/Programs";
import { GalleryMasonry } from "@/components/site/GalleryMasonry";
import { News } from "@/components/site/News";
import { FinalCTA } from "@/components/site/FinalCTA";
import { SiteFooter } from "@/components/site/SiteFooter";

export default function HomeV1() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <SkipToContent />
      <StickyHeader />
      <main id="content" tabIndex={-1} className="outline-none">
        <Hero />
        <IntentHub />
        <AboutHistory />
        <UpcomingEvents />
        <Programs />
        <GalleryMasonry />
        <News />
        <FinalCTA />
      </main>
      <SiteFooter />
    </>
  );
}
